import { gsap } from 'gsap/all'
import Swiper, { Pagination, Autoplay } from 'swiper'
// configure Swiper to use modules
Swiper.use([Pagination, Autoplay])
import 'swiper/css/pagination'

export function valueSlider(element: HTMLElement) {
  let mm = gsap.matchMedia()
  const slider = element.querySelector('.swiper') as HTMLElement
  const sliderPagination = element.querySelector('.swiper-pagination') as HTMLElement

  mm.add('(max-width: 992px)', () => {
    const swiper = new Swiper(slider, {
      // Optional parameters
      direction: 'horizontal',
      loop: true,
      // If we need pagination
      spaceBetween: 40,
      pagination: {
        el: sliderPagination,
        clickable: true
      }
    })
  })
}
